import PropTypes from "prop-types";
import React from "react";

import { inputPropTypes } from "@swa-ui/core";
import { TextFormField } from "@swa-ui/form";
import i18n from "@swa-ui/locale";

import {
  COMPANY_ID_MAX_LENGTH,
  COMPANY_ID_MIN_LENGTH,
  COMPANY_ID_SCHEMA_FIELD_NAME,
} from "./CompanyIdFormField.schema";

/**
 * CompanyIdFormField facilitates the input of a company ID.
 */

export const CompanyIdFormField = (props) => {
  const {
    componentProps,
    disabled,
    defaultValue,
    label = i18n("CompanyIdFormField__LABEL"),
    name = COMPANY_ID_SCHEMA_FIELD_NAME,
    readOnly = false,
  } = props;

  return <TextFormField {...getTextFormFieldProps()} />;

  function getTextFormFieldProps() {
    return {
      componentProps: {
        "aria-label": i18n("CompanyIdFormField__ARIA"),
        defaultValue,
        maxLength: COMPANY_ID_MAX_LENGTH,
        minLength: COMPANY_ID_MIN_LENGTH,
        readOnly,
        required: true,
        ...componentProps,
      },
      disabled,
      label,
      name,
    };
  }
};

CompanyIdFormField.propTypes = {
  /** Component props for input component. */
  componentProps: PropTypes.shape(inputPropTypes),

  /** Indicates whether the field is disabled. */
  disabled: PropTypes.bool,

  /** Content above the form field, used to identify the form field. */
  label: PropTypes.string,

  /** Form field name used in schema validation and service call payload. */
  name: PropTypes.string,

  /** Indicates whether the field is read-only. */
  readOnly: PropTypes.bool,

  /** Indicates whether the field is required. */
  required: PropTypes.bool,
};
